import BaseUI from "../../../core/src/ui/BaseUI";
import ViewManager from "../../../core/src/utils/ViewManager";
import { DefaultLayers } from "../../../core/src/utils/Layers";
import { UIUpdateEvent } from "../../../core/src/ui/UIUpdateEvents";
import TextField from "../../../core/src/views/components/TextField";
import App from "../../../core/src/App";
import Locale from "../../../core/src/utils/Locale";
import SpinModel from "../../../core/src/model/SpinModel";

export default class InfoBar extends BaseUI {
    protected infoBarLabel: TextField;
    protected defaultTexts: string[];
    protected fsTexts: string[];

    public create(): void {
        super.create();

        // Cache default texts
        if (App.config.infoBar?.translationKeys.default) {
            this.defaultTexts = [];

            App.config.infoBar.translationKeys.default.forEach((key) => {
                if(Locale.getString(key ) === key) {
                    let index = 0;
                    let concatString = "";
                    while (Locale.getString(key + index ) !== key + index) {
                        concatString += Locale.getString(key + index ) + " ";
                        index++;
                    }
                    this.defaultTexts.push(concatString);
                } else {
                    this.defaultTexts.push(Locale.getString(key));
                }
            });
        } else {
            this.defaultTexts = [""];
        }

        // Cache freespins texts
        if (App.config.infoBar?.translationKeys.freespins) {
            this.fsTexts = [];

            App.config.infoBar.translationKeys.freespins.forEach((key) => {
                this.fsTexts.push(Locale.getString(key));
            });
        } else {
            this.fsTexts = [""];
        }

        this.scene = ViewManager.getLayer(DefaultLayers.InfoBar).setScene();

        this.infoBarLabel = this.scene.sceneTextFields.get(
            "info_text"
        ) as TextField;
    }

    public update(event: UIUpdateEvent): void {
        if (this.scene) {
            switch (event) {
                case UIUpdateEvent.InfoBar:
                    let currentTexts = SpinModel.isInFreespins()
                        ? this.fsTexts
                        : this.defaultTexts;
                    let currentIndex = currentTexts.indexOf(
                        this.infoBarLabel.text
                    );
                    let nextIndex =
                        currentIndex >= currentTexts.length - 1
                            ? 0 // If it was the last one
                            : currentIndex + 1; // if not

                
                    this.infoBarLabel.text = currentTexts[nextIndex];
                    break;
            }
        }
    }
}
